export class ScheduleListItemModel {
    id: number;
    defaultUserMediaAppUrl: string;
    name: string;
    eventCount: number;
    defaultUserMediaAppType: string;
    urlError: boolean;
    medias: Array<number>;
    showDefaultIcon: boolean;
    isSelected: boolean;
}
